<template>
  <div>
    <div class="center" v-if="showLoading">
      <lottie :options="defaultOptionsSplashScreen" :height="300" :width="300" v-on:animCreated="handleAnimationSplashScreen"/>
    </div>
    <div v-else>
      <headerSection></headerSection>
      <div id="main__content" class="">
        <div class="x-main-container">
          <div class="x-main-content">
            <div class="x-promotion-index" :style="{'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
              <div class="container">
                <div class="row">
                  <div class="col-12">
                    <div class="x-page-title-component -long-support">
                      <div class="-inner-wrapper">
                        <h1 class="-title football-title">ทายผลบอล</h1>
                      </div>
                    </div>

                    <!-- BONUS CREDIT DISPLAY -->
                    <div class="bonus-display">
                      <div class="bonus-label">Bonus Credit</div>
                      <div class="bonus-amount">{{ bonusCredit }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container">
                <!-- NO GAMES -->
                <div v-if="openGames.length === 0" class="no-game-card">
                  <div class="no-game-icon">
                    <i class="fa fa-futbol-o"></i>
                  </div>
                  <p>ไม่มีเกมส์เปิดรับทายผลในขณะนี้</p>
                  <small>กลับมาใหม่เร็วๆ นี้</small>
                </div>

                <!-- MULTIPLE GAMES -->
                <div v-for="game in openGames" :key="game.id" class="game-section">
                  <!-- GAME INFO -->
                  <div class="game-info-card">
                    <div class="game-date">
                      <i class="fa fa-calendar mr-2"></i>
                      {{ game.date }}
                    </div>
                    <div class="game-times">
                      <span><i class="fa fa-clock-o mr-1"></i> รอบ: {{ game.round_time }}</span>
                      <span class="close-time"><i class="fa fa-times-circle mr-1"></i> ปิดรับ: {{ game.close_time }}</span>
                    </div>
                  </div>

                  <!-- CHECK IF GAME IS CLOSED -->
                  <div v-if="isGameClosed(game)" class="game-closed-warning">
                    <i class="fa fa-exclamation-triangle mr-2"></i>
                    เกมนี้ปิดรับทายผลแล้ว
                  </div>

                  <!-- CHECK IF ALREADY PREDICTED -->
                  <div v-else-if="hasAlreadyPredicted(game.id)" class="already-predicted">
                    <i class="fa fa-check-circle mr-2"></i>
                    คุณทายเกมส์นี้ไปแล้ว
                  </div>

                  <template v-else>
                    <!-- PROGRESS INDICATOR -->
                    <div class="pick-progress">
                      <div v-for="n in getRequiredPicks(game.id)" :key="n"
                           class="progress-dot"
                           :class="{ 'filled': getPickCount(game.id) >= n }">
                      </div>
                    </div>
                    <p class="progress-text">เลือกแล้ว {{ getPickCount(game.id) }} / {{ getRequiredPicks(game.id) }} คู่</p>

                    <!-- MATCH PAIRS -->
                    <div v-for="pair in game.pairs" :key="`${game.id}-${pair.pair_no}`"
                         class="match-card"
                         :class="{ 'selected': selectedPicksByGame[game.id] && selectedPicksByGame[game.id][pair.pair_no] }">
                      <div class="match-header">
                        <span class="match-number">คู่ที่ {{ pair.pair_no }}</span>
                      </div>
                      <div class="match-teams">
                        <button class="team-btn"
                                :class="{ 'active': selectedPicksByGame[game.id] && selectedPicksByGame[game.id][pair.pair_no] === 'home' }"
                                @click="selectPick(game.id, pair.pair_no, 'home')"
                                :disabled="isSubmitting">
                          <span class="team-name">{{ pair.home_team }}</span>
                          <span class="team-odds">{{ pair.odds_home }}</span>
                        </button>
                        <div class="vs-divider">
                          <span class="hdp-value">HDP {{ pair.hcp }}</span>
                        </div>
                        <button class="team-btn"
                                :class="{ 'active': selectedPicksByGame[game.id] && selectedPicksByGame[game.id][pair.pair_no] === 'away' }"
                                @click="selectPick(game.id, pair.pair_no, 'away')"
                                :disabled="isSubmitting">
                          <span class="team-name">{{ pair.away_team }}</span>
                          <span class="team-odds">{{ pair.odds_away }}</span>
                        </button>
                      </div>
                    </div>

                    <!-- CREDIT INPUT SECTION -->
                    <div class="credit-input-section">
                      <label class="credit-label">จำนวน Credit ที่จะใช้ (ขั้นต่ำ 20):</label>
                      <div class="credit-input-wrapper">
                        <input
                          type="number"
                          v-model.number="creditAmountByGame[game.id]"
                          class="credit-input"
                          :max="bonusCredit"
                          :min="20"
                          placeholder="ขั้นต่ำ 20"
                          :disabled="isSubmitting"
                        />
                        <span class="credit-max">/ {{ bonusCredit }}</span>
                      </div>
                      <button class="use-all-btn" @click="creditAmountByGame[game.id] = bonusCredit" :disabled="isSubmitting || bonusCredit < 20">
                        ใช้ทั้งหมด
                      </button>
                    </div>

                    <!-- SUBMIT BUTTON FOR THIS GAME -->
                    <div class="submit-section">
                      <button class="submit-btn"
                              @click="submitPrediction(game)"
                              :disabled="isSubmitting || !canSubmitGame(game.id)">
                        <span v-if="isSubmitting && submittingGameId === game.id">
                          <i class="fa fa-spinner fa-spin mr-2"></i>กำลังส่ง...
                        </span>
                        <span v-else>
                          <i class="fa fa-check mr-2"></i>ยืนยันทายผลเกมนี้
                        </span>
                      </button>
                    </div>
                  </template>
                </div>

                <!-- PREDICTION HISTORY -->
                <div class="history-section mt-4">
                  <div class="history-header" @click="showHistory = !showHistory">
                    <h5>
                      <i :class="showHistory ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" class="mr-2"></i>
                      ประวัติการทาย ({{ myPredictions.length }})
                    </h5>
                    <span class="toggle-icon">{{ showHistory ? 'ซ่อน' : 'แสดง' }}</span>
                  </div>

                  <div v-if="showHistory" class="history-list">
                    <div v-if="myPredictions.length === 0" class="no-history">
                      <p>ยังไม่มีประวัติการทาย</p>
                    </div>

                    <div v-for="pred in myPredictions" :key="pred.id"
                         class="prediction-card"
                         :class="pred.status">
                      <div class="prediction-header" @click="togglePrediction(pred.id)">
                        <div class="pred-info">
                          <span class="pred-date">{{ formatDate(pred.created_at) }}</span>
                          <span class="pred-credit">ใช้ {{ pred.credit_used }} credit</span>
                        </div>
                        <div class="pred-result">
                          <span class="status-badge" :class="pred.status">
                            {{ getStatusText(pred.status) }}
                          </span>
                          <span v-if="pred.net_profit > 0" class="profit">+{{ pred.net_profit }}</span>
                        </div>
                      </div>

                      <div v-if="expandedPrediction === pred.id" class="prediction-detail">
                        <div class="detail-row two-line" v-for="pick in pred.predictions" :key="pick.pair_no">
                          <div class="teams-line">
                            <span class="teams-name">{{ pick.home_team }} VS {{ pick.away_team }}</span>
                            <span v-if="getPickScore(pred, pick)" class="pick-score">{{ getPickScore(pred, pick) }}</span>
                          </div>
                          <div class="pick-line">
                            <div class="pick-line-center">
                              <span class="hcp-odds">HDP {{ pick.hcp || 0 }} @ {{ pick.odds }}</span>
                              <span class="picked-team">{{ getPickedTeamName(pick) }}</span>
                            </div>
                            <div class="pick-line-right">
                              <span class="pick-result" :class="getEffectiveResultClass(pred, pick)">
                                {{ getEffectiveResultText(pred, pick) }}
                              </span>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <!-- INFO SECTION -->
                <div class="info-card mt-4">
                  <h5><i class="fa fa-info-circle mr-2"></i>วิธีเล่น</h5>
                  <ul>
                    <li>ฝากเงินเพื่อสะสม Bonus Credit</li>
                    <li>เลือกทายผล {{ requiredPicks }} คู่ (สเต็ป)</li>
                    <li>ถ้าทายถูก จะได้ Reward Code ไปกรอกรับเครดิต</li>
                    <li>Bonus Credit จะรีเซ็ตทุกเที่ยงคืน</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footerSection></footerSection>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/functions'
import router from './../router'
import Lottie from './lottie.vue'
import * as animateSantaWalk from '../assets/loading.json'

export default {
  name: 'Football',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    lottie: Lottie
  },
  data() {
    return {
      showLoading: true,
      defaultOptionsSplashScreen: null,
      openGames: [],
      selectedPicksByGame: {},
      isSubmitting: false,
      submittingGameId: null,
      bonusCredit: 0,
      requiredPicksByGame: {},   // per-game required_picks
      settings: null,
      // History
      myPredictions: [],
      showHistory: false,
      expandedPrediction: null,
      // Credit amount per game
      creditAmountByGame: {},
    }
  },
  computed: {
    user() {
      return this.$store.state.user.user
    }
  },
  created() {
    const user = localStorage.getItem('userData')
    if (user) {
      const _user = JSON.parse(user)
      this.$store.dispatch('user/setUser', _user).then(() => {
        this.loadData()
      }).catch(err => { console.error(err) })
    } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
    }

    const animateSplashScreen = animateSantaWalk.default
    this.defaultOptionsSplashScreen = { animationData: animateSplashScreen, autoplay: false, loop: false }
  },
  mounted() {
    this.animSplashScreen && this.animSplashScreen.play()
    setTimeout(() => {
      this.showLoading = false
      this.animSplashScreen && this.animSplashScreen.stop()
    }, 2000)
  },
  methods: {
    handleAnimationSplashScreen(anim) {
      this.animSplashScreen = anim
    },
    async loadData() {
      try {
        // Load settings (for bonus calculation etc, not for required_picks)
        const settingsSnap = await firebase.database().ref('/football_settings').once('value')
        this.settings = settingsSnap.val()

        // Load user's bonus_credit
        const userSnap = await firebase.database().ref(`/users/${this.user.key}/bonus_credit`).once('value')
        this.bonusCredit = userSnap.val() || 0

        // Load ALL open games
        const gamesSnap = await firebase.database().ref('/football_games')
          .orderByChild('status')
          .equalTo('open')
          .once('value')

        const games = gamesSnap.val()
        if (games) {
          this.openGames = Object.keys(games).map(id => ({
            id,
            ...games[id]
          }))
          // Sort by date + round_time
          this.openGames.sort((a, b) => {
            const dateA = `${a.date} ${a.round_time}`
            const dateB = `${b.date} ${b.round_time}`
            return dateA.localeCompare(dateB)
          })

          // Initialize per-game data
          this.openGames.forEach(game => {
            this.$set(this.selectedPicksByGame, game.id, {})
            this.$set(this.creditAmountByGame, game.id, 0)
            // Set requiredPicks from game settings (per-game, default 4)
            this.$set(this.requiredPicksByGame, game.id, game.required_picks || 4)
          })
        }

        // Load prediction history
        await this.loadMyPredictions()
      } catch (error) {
        console.error('Load data error:', error)
      }
    },
    async loadMyPredictions() {
      try {
        const snap = await firebase.firestore()
          .collection('football_predictions')
          .where('user_key', '==', this.user.key)
          .orderBy('created_at', 'desc')
          .limit(20)
          .get()

        this.myPredictions = snap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
      } catch (error) {
        console.error('Load predictions error:', error)
      }
    },
    selectPick(gameId, pairNo, pick) {
      if (!this.selectedPicksByGame[gameId]) {
        this.$set(this.selectedPicksByGame, gameId, {})
      }

      if (this.selectedPicksByGame[gameId][pairNo] === pick) {
        // Deselect
        this.$delete(this.selectedPicksByGame[gameId], pairNo)
      } else {
        // Check if already at max picks (and not switching pick on same pair)
        const currentCount = Object.keys(this.selectedPicksByGame[gameId]).length
        const isChangingExistingPick = this.selectedPicksByGame[gameId][pairNo] !== undefined
        const requiredPicks = this.getRequiredPicks(gameId)

        if (currentCount >= requiredPicks && !isChangingExistingPick) {
          // Already at max picks, show popup
          this.$swal('กดครบแล้ว', `คุณเลือกครบ ${requiredPicks} คู่แล้ว กรุณายกเลิกการเลือกคู่อื่นก่อน`, 'warning')
          return
        }

        // Select
        this.$set(this.selectedPicksByGame[gameId], pairNo, pick)
      }
    },
    getPickCount(gameId) {
      if (!this.selectedPicksByGame[gameId]) return 0
      return Object.keys(this.selectedPicksByGame[gameId]).length
    },
    getRequiredPicks(gameId) {
      return this.requiredPicksByGame[gameId] || 4
    },
    isGameClosed(game) {
      if (!game || !game.date || !game.close_time) return false

      // สร้าง datetime ของเวลาปิดรับ
      const closeDateTime = new Date(`${game.date}T${game.close_time}:00`)
      const now = new Date()

      return now >= closeDateTime
    },
    canSubmitGame(gameId) {
      const game = this.openGames.find(g => g.id === gameId)
      if (!game) return false

      const creditAmount = this.creditAmountByGame[gameId] || 0
      const requiredPicks = this.getRequiredPicks(gameId)

      return this.getPickCount(gameId) === requiredPicks
        && this.bonusCredit >= 20              // ต้องมี credit อย่างน้อย 20
        && creditAmount >= 20                  // ต้องกรอก credit ขั้นต่ำ 20
        && creditAmount <= this.bonusCredit    // credit ต้องพอ
        && !this.isGameClosed(game)
    },
    hasAlreadyPredicted(gameId) {
      return this.myPredictions.some(pred => pred.game_id === gameId)
    },
    async submitPrediction(game) {
      if (this.isSubmitting) return
      const gameId = game.id

      // Validate credit amount
      const creditAmount = this.creditAmountByGame[gameId] || 0
      if (creditAmount < 20) {
        this.$swal('แจ้งเตือน', 'จำนวน Credit ขั้นต่ำคือ 20', 'warning')
        return
      }
      if (creditAmount > this.bonusCredit) {
        this.$swal('แจ้งเตือน', 'Credit ไม่เพียงพอ', 'warning')
        return
      }

      if (!this.canSubmitGame(gameId)) {
        this.$swal('แจ้งเตือน', `กรุณาเลือกให้ครบ ${this.requiredPicks} คู่`, 'warning')
        return
      }

      this.isSubmitting = true
      this.submittingGameId = gameId

      try {
        const picks = this.selectedPicksByGame[gameId]

        // Build predictions array (including hcp for history display)
        const predictions = Object.keys(picks).map(pairNo => {
          const pair = game.pairs.find(p => p.pair_no === parseInt(pairNo))
          const pick = picks[pairNo]
          const odds = pick === 'home' ? pair.odds_home : pair.odds_away
          return {
            pair_no: parseInt(pairNo),
            pick,
            odds,
            hcp: pair.hcp,
            home_team: pair.home_team,
            away_team: pair.away_team
          }
        })

        // Generate idempotency key to prevent double submission
        const idempotencyKey = `${this.user.key}_${gameId}_${Date.now()}`

        // Call Cloud Function (asia-east2 region)
        const submitPrediction = firebase.app().functions('asia-east2').httpsCallable('submitPrediction')
        const result = await submitPrediction({
          game_id: gameId,
          predictions,
          user_key: this.user.key,
          credit_amount: creditAmount,          // จำนวน credit ที่ใช้
          idempotency_key: idempotencyKey       // ป้องกัน double submit
        })

        if (result.data.success) {
          this.$swal('สำเร็จ!', `ทายผลเรียบร้อยแล้ว! ใช้ ${result.data.credit_used} credit`, 'success')
          this.$set(this.selectedPicksByGame, gameId, {})
          this.$set(this.creditAmountByGame, gameId, 0)  // Reset credit input
          this.bonusCredit -= result.data.credit_used
          // Reload predictions
          await this.loadMyPredictions()
        }
      } catch (error) {
        console.error('Submit prediction error:', error)
        this.$swal('เกิดข้อผิดพลาด', error.message || 'ไม่สามารถส่งทายผลได้', 'error')
      } finally {
        this.isSubmitting = false
        this.submittingGameId = null
      }
    },
    togglePrediction(predId) {
      if (this.expandedPrediction === predId) {
        this.expandedPrediction = null
      } else {
        this.expandedPrediction = predId
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp)
      return date.toLocaleDateString('th-TH', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    getStatusText(status) {
      switch (status) {
        case 'win': return 'ชนะ'
        case 'lose': return 'แพ้'
        case 'pending': return 'รอผล'
        default: return status
      }
    },
    getPickResultClass(pick) {
      if (!pick.result) return 'pending'
      if (pick.result === 'win_full' || pick.result === 'win_half') return 'win'
      if (pick.result === 'lose_full' || pick.result === 'lose_half') return 'lose'
      return 'draw'
    },
    getPickResultText(pick) {
      if (!pick.result) return ''
      switch (pick.result) {
        case 'win_full': return 'ชนะเต็ม'
        case 'win_half': return 'ชนะครึ่ง'
        case 'draw': return 'เสมอ'
        case 'lose_half': return 'แพ้ครึ่ง'
        case 'lose_full': return 'แพ้เต็ม'
        default: return pick.result
      }
    },
    getPickScore(pred, pick) {
      // หาสกอร์จาก calc_details
      if (pred.calc_details) {
        const detail = pred.calc_details.find(d => d.pair_no === pick.pair_no)
        if (detail && detail.home_score !== undefined) {
          return `${detail.home_score}-${detail.away_score}`
        }
      }
      return null
    },
    // ดึง effective_result จากมุมมองผู้ทาย (ไม่ใช่มุมมองทีมเหย้า)
    getEffectiveResult(pred, pick) {
      if (pred.calc_details) {
        const detail = pred.calc_details.find(d => d.pair_no === pick.pair_no)
        if (detail && detail.effective_result) {
          return detail.effective_result
        }
      }
      return null
    },
    getEffectiveResultClass(pred, pick) {
      const result = this.getEffectiveResult(pred, pick)
      if (!result) return 'pending'
      if (result === 'win_full' || result === 'win_half') return 'win'
      if (result === 'lose_full' || result === 'lose_half') return 'lose'
      return 'draw'
    },
    getEffectiveResultText(pred, pick) {
      const result = this.getEffectiveResult(pred, pick)
      if (!result) return 'รอผล'
      switch (result) {
        case 'win_full': return 'ชนะเต็ม'
        case 'win_half': return 'ชนะครึ่ง'
        case 'draw': return 'เสมอ'
        case 'lose_half': return 'แพ้ครึ่ง'
        case 'lose_full': return 'แพ้เต็ม'
        default: return result
      }
    },
    getPickedTeamName(pick) {
      return pick.pick === 'home' ? pick.home_team : pick.away_team
    }
  }
}
</script>

<style scoped>
/* Purple/Gold Gradient Theme */
.football-title {
  font-size: 24px;
  color: #fbc844;
  text-shadow: 0 0 20px rgba(251, 200, 68, 0.5);
}

/* Bonus Display */
.bonus-display {
  background: linear-gradient(180deg, #492666, #8309a2);
  border: 2px solid #fbc844;
  border-radius: 15px;
  padding: 20px;
  text-align: center;
  margin-bottom: 25px;
  box-shadow: 0 5px 30px rgba(131, 9, 162, 0.4);
}

.bonus-label {
  color: #fff;
  font-size: 14px;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.bonus-amount {
  font-size: 42px;
  font-weight: bold;
  color: #fbc844;
  text-shadow: 0 0 15px rgba(251, 200, 68, 0.5);
}

/* No Game Card */
.no-game-card {
  background: linear-gradient(180deg, #492666, #8309a2);
  border: 1px solid rgba(251, 200, 68, 0.3);
  border-radius: 15px;
  padding: 50px 20px;
  text-align: center;
  color: #fff;
}

.no-game-icon {
  font-size: 60px;
  color: #fbc844;
  margin-bottom: 20px;
  opacity: 0.7;
}

.no-game-card p {
  font-size: 18px;
  margin-bottom: 5px;
}

.no-game-card small {
  color: rgba(255, 255, 255, 0.6);
}

/* Game Section */
.game-section {
  background: linear-gradient(180deg, rgba(73, 38, 102, 0.9), rgba(131, 9, 162, 0.8));
  border: 2px solid rgba(251, 200, 68, 0.4);
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 25px;
  box-shadow: 0 5px 30px rgba(131, 9, 162, 0.3);
}

/* Game Info Card */
.game-info-card {
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.2));
  border: 1px solid rgba(251, 200, 68, 0.3);
  border-radius: 12px;
  padding: 15px 20px;
  margin-bottom: 20px;
  color: #fff;
}

.game-date {
  font-size: 18px;
  font-weight: bold;
  color: #fbc844;
  margin-bottom: 8px;
}

.game-times {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.close-time {
  color: #ff6b6b;
}

/* Already Predicted */
.already-predicted {
  background: rgba(40, 199, 111, 0.2);
  border: 1px solid #28c76f;
  border-radius: 10px;
  padding: 15px 20px;
  text-align: center;
  color: #28c76f;
  font-weight: bold;
  margin-bottom: 15px;
}

/* Game Closed Warning */
.game-closed-warning {
  background: rgba(234, 84, 85, 0.2);
  border: 1px solid #ea5455;
  border-radius: 10px;
  padding: 15px 20px;
  text-align: center;
  color: #ea5455;
  font-weight: bold;
  margin-bottom: 15px;
}

/* Progress Indicator */
.pick-progress {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 10px;
}

.progress-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(251, 200, 68, 0.4);
  transition: all 0.3s ease;
}

.progress-dot.filled {
  background: #fbc844;
  border-color: #fbc844;
  box-shadow: 0 0 12px #fbc844;
}

.progress-text {
  text-align: center;
  color: #fff;
  font-size: 14px;
  margin-bottom: 20px;
}

/* Match Card */
.match-card {
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.2));
  border: 1px solid rgba(251, 200, 68, 0.2);
  border-radius: 12px;
  padding: 10px 12px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.match-card.selected {
  border-color: #fbc844;
  box-shadow: 0 0 25px rgba(251, 200, 68, 0.3);
}

.match-header {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(251, 200, 68, 0.2);
}

.match-number {
  color: #fbc844;
  font-weight: bold;
  font-size: 14px;
}

.match-teams {
  display: flex;
  align-items: stretch;
  gap: 10px;
}

.team-btn {
  flex: 1;
  padding: 10px 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(251, 200, 68, 0.3);
  border-radius: 10px;
  color: #fff;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.team-btn:hover:not(:disabled) {
  background: rgba(251, 200, 68, 0.15);
  border-color: #fbc844;
}

.team-btn.active {
  background: linear-gradient(180deg, #ba7f24, #a424cc);
  border-color: #fbc844;
  color: #fff;
}

.team-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.team-name {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 5px;
  text-align: center;
}

.team-odds {
  font-size: 20px;
  font-weight: bold;
  color: #fbc844;
}

.team-btn.active .team-odds {
  color: #fff;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

.vs-divider {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  min-width: 60px;
}

.hdp-value {
  color: #fbc844;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  background: rgba(251, 200, 68, 0.15);
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid rgba(251, 200, 68, 0.3);
}

/* Credit Input Section */
.credit-input-section {
  margin: 20px 0;
  text-align: center;
  padding: 15px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  border: 1px solid rgba(251, 200, 68, 0.2);
}

.credit-label {
  color: #fbc844;
  font-size: 14px;
  margin-bottom: 10px;
  display: block;
}

.credit-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.credit-input {
  width: 130px;
  padding: 12px 15px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(251, 200, 68, 0.4);
  border-radius: 10px;
  color: #fbc844;
}

.credit-input:focus {
  outline: none;
  border-color: #fbc844;
  box-shadow: 0 0 15px rgba(251, 200, 68, 0.3);
}

.credit-input:disabled {
  opacity: 0.6;
}

.credit-input::placeholder {
  color: rgba(255, 255, 255, 0.3);
  font-size: 14px;
}

.credit-max {
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
}

.use-all-btn {
  margin-top: 12px;
  padding: 8px 25px;
  background: transparent;
  border: 1px solid rgba(251, 200, 68, 0.5);
  border-radius: 8px;
  color: #fbc844;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.use-all-btn:hover:not(:disabled) {
  background: rgba(251, 200, 68, 0.15);
  border-color: #fbc844;
}

.use-all-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Submit Section */
.submit-section {
  text-align: center;
  margin: 25px 0 10px;
}

.submit-btn {
  background: linear-gradient(180deg, #ba7f24, #fbc844);
  border: none;
  border-radius: 12px;
  padding: 18px 50px;
  font-size: 18px;
  font-weight: bold;
  color: #000;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 20px rgba(186, 127, 36, 0.4);
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(251, 200, 68, 0.5);
}

.submit-btn:disabled {
  background: #555;
  color: #888;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* History Section */
.history-section {
  background: linear-gradient(180deg, rgba(73, 38, 102, 0.9), rgba(131, 9, 162, 0.8));
  border: 1px solid rgba(251, 200, 68, 0.3);
  border-radius: 15px;
  overflow: hidden;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.2);
  transition: background 0.3s ease;
}

.history-header:hover {
  background: rgba(0, 0, 0, 0.3);
}

.history-header h5 {
  color: #fbc844;
  margin: 0;
  font-size: 16px;
}

.toggle-icon {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}

.history-list {
  padding: 15px;
}

.no-history {
  text-align: center;
  padding: 30px;
  color: rgba(255, 255, 255, 0.5);
}

/* Prediction Card */
.prediction-card {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  margin-bottom: 10px;
  overflow: hidden;
  border-left: 4px solid #666;
}

.prediction-card.win {
  border-left-color: #28c76f;
}

.prediction-card.lose {
  border-left-color: #ea5455;
}

.prediction-card.pending {
  border-left-color: #fbc844;
}

.prediction-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.prediction-header:hover {
  background: rgba(251, 200, 68, 0.1);
}

.pred-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.pred-date {
  color: #fff;
  font-size: 14px;
}

.pred-credit {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
}

.pred-result {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
}

.status-badge.win {
  background: rgba(40, 199, 111, 0.2);
  color: #28c76f;
}

.status-badge.lose {
  background: rgba(234, 84, 85, 0.2);
  color: #ea5455;
}

.status-badge.pending {
  background: rgba(251, 200, 68, 0.2);
  color: #fbc844;
}

.profit {
  color: #28c76f;
  font-weight: bold;
  font-size: 16px;
}

/* Prediction Detail */
.prediction-detail {
  padding: 15px;
  background: rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(251, 200, 68, 0.1);
}

.detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(251, 200, 68, 0.1);
  color: #fff;
  font-size: 13px;
}

.detail-row:last-child {
  border-bottom: none;
}

/* Two-line layout */
.detail-row.two-line {
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0;
}

.teams-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 6px;
}

.teams-name {
  font-size: 13px;
  color: #fff;
  font-weight: 500;
}

.pick-line {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  font-size: 12px;
}

.pick-line-center {
  flex: 1;
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 10px;
}

.pick-line-right {
  margin-left: auto;
}

.hcp-odds {
  color: #fbc844;
}

.picked-team {
  color: #28c76f;
  font-weight: 500;
}

.pair-info {
  flex: 1;
  color: #fff;
}

.pick-score {
  font-weight: bold;
  color: #ffd700;
  font-size: 14px;
}

.pick-result {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  min-width: 60px;
  text-align: right;
}

.pick-result.win {
  background: rgba(40, 199, 111, 0.2);
  color: #28c76f;
}

.pick-result.lose {
  background: rgba(234, 84, 85, 0.2);
  color: #ea5455;
}

.pick-result.draw {
  background: rgba(251, 200, 68, 0.2);
  color: #fbc844;
}

.pick-result.pending {
  background: rgba(255, 159, 67, 0.2);
  color: #ff9f43;
}

/* Reward Section */
.reward-section {
  margin-top: 15px;
  padding: 12px;
  background: rgba(40, 199, 111, 0.15);
  border: 1px solid rgba(40, 199, 111, 0.3);
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.reward-label {
  color: #28c76f;
  font-size: 13px;
}

.reward-code {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 3px;
}

.redeemed-badge {
  background: rgba(234, 84, 85, 0.2);
  color: #ea5455;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 11px;
}

/* Info Card */
.info-card {
  background: linear-gradient(180deg, rgba(73, 38, 102, 0.8), rgba(131, 9, 162, 0.7));
  border: 1px solid rgba(251, 200, 68, 0.2);
  border-radius: 12px;
  padding: 20px;
  color: #fff;
  margin-bottom: 30px;
}

.info-card h5 {
  color: #fbc844;
  margin-bottom: 15px;
  font-size: 16px;
}

.info-card ul {
  margin: 0;
  padding-left: 20px;
}

.info-card li {
  margin-bottom: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
}

/* Mobile Responsive */
@media (max-width: 576px) {
  .game-section {
    padding: 12px;
  }

  .match-card {
    padding: 8px 10px;
    margin-bottom: 8px;
  }

  .team-btn {
    padding: 8px 5px;
  }

  .team-name {
    font-size: 11px;
  }

  .team-odds {
    font-size: 16px;
  }

  .hdp-value {
    font-size: 10px;
    padding: 3px 6px;
  }

  .vs-divider {
    min-width: 50px;
    padding: 0 4px;
  }

  .submit-btn {
    padding: 15px 30px;
    font-size: 16px;
    width: 100%;
  }
}
</style>
